import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { 
  Mail, 
  Phone, 
  MapPin, 
  Clock,
  Send,
  MessageSquare,
  Users,
  Calendar
} from "lucide-react";

const Contact = () => {
  const contactInfo = [
    {
      icon: Mail,
      title: "Email Us",
      details: "contact@smartborn.io",
      description: "Get a response within 24 hours"
    },
    {
      icon: Phone,
      title: "Call Us",
      details: "+91 98869 28201",
      description: "Mon-Fri 9AM-7PM IST"
    },
    {
      icon: MapPin,
      title: "Visit Us",
      details: "PID No-14, new, 49, 2nd floor ,VLVC Plaza, 39-49, 19th Main Rd, 1st Block, Rajajinagar, Bengaluru, Karnataka 560010",
      description: "Schedule an appointment"
    },
    {
      icon: Clock,
      title: "Business Hours",
      details: "Monday - Friday: 9AM-7PM IST",
      description: "Weekend support available"
    }
  ];

  const offices = [
    {
      city: "Rajajinagar, Bangalore",
      address: "PID No-14, new 49, 2nd floor, VLVC Plaza, \n 39-49, 19th Main Rd, 1st Block, Rajajinagar, \n Bengaluru, Karnataka 560010",
      phone: "+91 98869 28201",
      email: "contact@smartborn.io"
    },
    {
      city: "MG Road, Bangalore",
      address: "205, Brigade Gardens, \n 19, Church St, Shanthala Nagar, Ashok Nagar, \n Bengaluru, Karnataka 560001",
      phone: "+91 98869 28201",
      email: "contact@smartborn.io"
    },
    {
      city: "Australia, Melbourne",
      address: "1 Koala Close, \n Throsby ACT 2914, \n Australia",
      phone: "+91 82203 45083",
      email: "contact@smartborn.io"
    },
    // {
    //   city: "Bangalore",
    //   address: "321 Tech Park, Bangalore, India 560001",
    //   phone: "+91 80 1234 5678",
    //   email: "bangalore@smartborn.com"
    // }
  ];

  return (
    <section id="contact" className="py-12 md:py-16 lg:py-20 bg-gradient-subtle">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 bg-gradient-primary bg-clip-text text-transparent pb-2">
            Ready to Transform Your Business?
          </h2>
          <p className="text-lg md:text-xl text-foreground max-w-3xl mx-auto mb-3 px-4">
            <strong>Start your project today</strong> and join 180+ companies achieving measurable growth
          </p>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto px-4">
            Get a free consultation and detailed project roadmap within 24 hours
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 mb-8 md:mb-12">
          {/* Contact Form */}
          <Card className="bg-gradient-card border-0 shadow-card hover:shadow-elegant transition-all duration-300">
            <CardHeader className="pb-6">
              <CardTitle className="text-xl md:text-2xl font-bold text-foreground flex items-center gap-3">
                <MessageSquare className="h-6 w-6 text-primary" />
                Send us a Message
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-medium text-foreground mb-2 block">
                    First Name *
                  </label>
                  <Input placeholder="John" className="bg-background" />
                </div>
                <div>
                  <label className="text-sm font-medium text-foreground mb-2 block">
                    Last Name *
                  </label>
                  <Input placeholder="Doe" className="bg-background" />
                </div>
              </div>
              
              <div>
                <label className="text-sm font-medium text-foreground mb-2 block">
                  Email Address *
                </label>
                <Input 
                  type="email" 
                  placeholder="john.doe@company.com" 
                  className="bg-background" 
                />
              </div>
              
              <div>
                <label className="text-sm font-medium text-foreground mb-2 block">
                  Phone Number
                </label>
                <Input 
                  type="tel" 
                  placeholder="+91 98869 28201" 
                  className="bg-background" 
                />
              </div>
              
              <div>
                <label className="text-sm font-medium text-foreground mb-2 block">
                  Company
                </label>
                <Input placeholder="Your Company" className="bg-background" />
              </div>
              
              <div>
                <label className="text-sm font-medium text-foreground mb-2 block">
                  Project Details *
                </label>
                <Textarea 
                  placeholder="Tell us about your project requirements, timeline, and budget..."
                  className="bg-background min-h-[120px]"
                />
              </div>
              
              <Button variant="cta" size="lg" className="w-full">
                Get My Free Consultation
                <Send className="ml-2 h-5 w-5" />
              </Button>
              <p className="text-xs text-muted-foreground text-center mt-2">
                📞 Expect a response within 24 hours · No commitment required
              </p>
            </CardContent>
          </Card>

          {/* Contact Information */}
          <div className="space-y-8">
            <div className="grid grid-cols-1 gap-6">
              {contactInfo.map((info, index) => (
                <Card key={index} className="bg-gradient-card border-0 shadow-card hover:shadow-elegant transition-all duration-300">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-4">
                      <div className="bg-gradient-primary p-3 rounded-lg">
                        <info.icon className="h-6 w-6 text-white" />
                      </div>
                      <div>
                        <h4 className="text-lg font-semibold text-foreground mb-1">
                          {info.title}
                        </h4>
                        <p className="text-foreground font-medium mb-1">
                          {info.details}
                        </p>
                        <p className="text-muted-foreground text-sm">
                          {info.description}
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>

          </div>
        </div>

        {/* Global Offices */}
        <div>
          <h3 className="text-3xl font-bold text-center mb-12 text-foreground">
            Our Offices
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"> 
            {offices.map((office, index) => (
              <Card key={index} className="bg-gradient-card border-0 shadow-card hover:shadow-elegant transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <h4 className="text-lg font-semibold text-foreground mb-4">
                    {office.city}
                  </h4>
                  <div className="space-y-3 text-sm text-muted-foreground">
                    <div className="flex items-start gap-2">
                      <MapPin className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
                      <span className="whitespace-pre-line text-left block">{office.address}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Phone className="h-4 w-4 text-primary" />
                      <span>{office.phone}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Mail className="h-4 w-4 text-primary" />
                      <span>{office.email}</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;